import { Component, OnInit, OnChanges, Input, SimpleChanges, Renderer2, ElementRef, Output, EventEmitter } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-modal-content',
    templateUrl: './modal-content.shared.component.html',
    styleUrls: ['./modal-content.shared.component.scss']
})
export class ModalContentComponent implements OnInit, OnChanges {
    @Input() public shadow!: boolean;
    @Input() public shadowBottom!: boolean;
    @Input() public shadowTop!: boolean;
    @Input() public modalData: State.IModal;
    @Input() public center: boolean = false;
    @Input() public verticalAlign: OLO.Components.ALIGN_V = 'centerV';
    @Input() public minHeight: number = 0;
    @Input() public dynamicHeight: boolean = false;
    @Input() public dimmedBg: boolean = false;
    @Input() public fullPaddings: boolean = false;

    @Output() public onScrollInit: EventEmitter<HTMLElement> = new EventEmitter();
    @Output() public onScrollY: EventEmitter<HTMLElement> = new EventEmitter();

    constructor(
        public renderer2: Renderer2,
        public elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        if (!this.dynamicHeight) {
            this.renderer2.addClass(this.elementRef.nativeElement, `-align-v-${this.verticalAlign}`.replace('centerV', 'center'));

        } else {
            this.renderer2.addClass(this.elementRef.nativeElement, `-align-v-stretch`);
        }

        if (this.minHeight) {
            this.renderer2.setStyle(this.elementRef.nativeElement, `min-height`, `${this.minHeight}px`);
        }


    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.shadow) {
            if (this.shadow === true) {
                if (this.shadowBottom === undefined) {
                    this.shadowBottom = true;
                }

                if (this.shadowTop === undefined) {
                    this.shadowTop = true;
                }
            }

            if (this.shadow === false) {
                this.shadowBottom = false;
                this.shadowTop = false;
            }
        }
    }

    public handleScrollInit($event: HTMLElement): void {
        this.onScrollInit.emit($event);
    }

    public handleScrollY($event: HTMLElement): void {
        this.onScrollY.emit($event);
    }
}
